import React from "react";
import styles from "../../management/db-list/DBList.module.scss";
import { SonicFacilityData } from "../../../common/classes/SonicFacility";
import ActionBtn from "../../../common/management/ActionBtn";

type Props = {
  facilities: Array<SonicFacilityData>;
};
const ReleaseFacilityList: React.FC<Props> = ({ facilities }) => {
  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["release"]}`}
      >
        <div>施設名</div>
        <div>都道府県</div>
        <div>会員登録</div>
        <div>メールアドレス</div>
        <div>アクション</div>
      </div>
      {facilities?.map((facility) => (
        <div
          className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["release"]}`}
          key={facility.id}
        >
          <div>{facility.name}</div>
          <div>{facility.prefecture ?? "未設定"}</div>
          <div>{facility.owner?.name ?? "未設定"}</div>
          <div>{facility.owner?.email ?? "未設定"}</div>
          <div className={styles["f-dbList__category-body__action"]}>
            <ActionBtn
              label="対応する"
              icon={["fal", "edit"]}
              link={`/admin/facility/release/${facility.id}`}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReleaseFacilityList;
